import React, { Children, useState, useEffect } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const blueColor = "#2196F3"
const greyColor = "#ccc"

const SwitchContainer = styled.div`
  display: flex;
  align-items: ${({ alignItems }) => (alignItems ? alignItems : "")};
  .switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 16px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: ${({ cursor }) => cursor || "pointer"};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${greyColor};
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 0px;
    bottom: -2px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    box-shadow: 0px 0px 10px 0px #707070;
  }

  input:checked + .slider {
    background-color: ${({ sliderColorOn }) => (sliderColorOn ? sliderColorOn : blueColor)};
  }

  input:focus + .slider {
    box-shadow: 0 0 1px ${({ sliderColorOn }) => (sliderColorOn ? sliderColorOn : blueColor)};
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(20px);
    -ms-transform: translateX(20px);
    transform: translateX(20px);
  }

  .slider.round {
    border-radius: 34px;
    background-color: ${({ sliderColorOff }) => sliderColorOff};
  }

  .slider.round:before {
    border-radius: 50%;
    background-color: ${({ bulletColor }) => bulletColor};
  }

  label {
    margin-bottom: 0px;
  }
`
function GenericSwitchV2({
  value,
  onToggleChange,
  bulletColor,
  role,
  name,
  sliderColorOn,
  sliderColorOff,
  cursor,
  alignItems,
  disabled,
}) {
  return (
    <SwitchContainer
      bulletColor={bulletColor}
      sliderColorOn={sliderColorOn}
      sliderColorOff={sliderColorOff}
      cursor={cursor}
      alignItems={alignItems}
    >
      <label className="switch">
        <input
          type="checkbox"
          name={name}
          role={role}
          onChange={onToggleChange}
          checked={value}
          disabled={disabled}
        />
        <span className="slider round" />
      </label>
    </SwitchContainer>
  )
}

GenericSwitchV2.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func,
  role: PropTypes.string,
  dataTestId: PropTypes.string,
  bulletColor: PropTypes.string,
  sliderColorOn: PropTypes.string,
  sliderColorOff: PropTypes.string,
  cursor: PropTypes.string,
  alignItems: PropTypes.string,
  disabled: PropTypes.bool,
}

GenericSwitchV2.defaultProps = {
  value: true,
  onChange: () => {},
  role: "switchRole",
  bulletColor: "white",
  sliderColorOn: blueColor,
  sliderColorOff: greyColor,
  cursor: "pointer",
  alignItems: "",
}

export default GenericSwitchV2
